const FormResources = {

    form_data:
    {
        master_step_code_id:          [],
        inspection_template_id:       '',
    },

    form_format:[
        // {
        //     css_class:  'col-md-6',
        //     type:       'select-multiple',
        //     maxlength:  10,
        //     disabled:   false,
        //     step:       '',
        //     name:       'Room Inventory Item:',
        //     model_name: 'room_qc_inventory_item_id',
        //     ref:        'room_qc_inventory_item_id_input',
        //     ref_alt:    'room_qc_inventory_item_id_input_alt',
        //     required:   true,
        // },
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Correction Required:',
            model_name: 'correction_required',
            ref:        'correction_required_input',
            ref_alt:    'correction_required_input_alt',
            required:   false,
        },
        // {
        //     css_class:  'col-md-12',
        //     type:       'select-multiple',
        //     maxlength:  10,
        //     disabled:   false,
        //     step:       '',
        //     name:       'Master Step:',
        //     model_name: 'master_step_code_id',
        //     ref:        'master_step_code_id_input',
        //     ref_alt:    'master_step_code_id_input_alt',
        //     required:   true,
        // },
        // {
        //     css_class:  'col-md-6',
        //     type:       'radio',
        //     maxlength:  '',
        //     disabled:   false,
        //     step:       '',
        //     name:       'Status:',
        //     model_name: 'pf_na',
        //     ref:        'pf_na_input',
        //     ref_alt:    'pf_na_input_alt',
        //     required:   false,
        //     childs: [
        //         {
        //             ref:            1,
        //             name:           'Pass',
        //         },
        //         {
        //             ref:            2,
        //             name:           'Fail',
        //         },
        //         {
        //             ref:            3,
        //             name:           'N/A',
        //         },
        //     ]
        // },
    ]

}

export default FormResources;